import StageTabs from "./StageTabs";

export default StageTabs;
